<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>모바일앱에서도 글 작성이 가능한 트링카</h1>
                        <p>트링카는 AI 기반으로 모바일 앱을 실행하여 앱 내에서도 실시간으로 작문 지원을 받을 수 있습니다. 트링카의 정밀한 글쓰기 제안을 다양한 방식으로 사용자에게 제공하여 고유한
                            <br>솔루션을 구축해 보세요.
                        </p>
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/technologyPlatform.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>사용자에 맞게 맞춤형으로 제공되는 통합 애플리케이션
                        </h2>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="most_suited_point">
                        <ul>
                            <li>콘텐츠 관리 시스템</li>
                            <li>온라인 글쓰기 플랫폼</li>
                            <li>메시지 앱/소셜 플랫폼</li>
                            <li>CRM + 업무 지원 소프트웨어</li>
                            <li>이메일 클라이언트</li>
                            <li>프로젝트 관리 소프트웨어</li>
                            <li>E-러닝 플랫폼</li>
                            <li>학습 관리 시스템</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>Trusted by Global Leaders</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/j-j.png" alt="">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/cigna.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/novartis.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/merck.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/abbvie.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/amgen.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/biogen.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/who.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/accelera.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/pfizer.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div> -->
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>제품 고유의 경험을 바탕으로 더욱더 강화해 주는 기능</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카의 모든 기능에 무제한으로 접근하여 제품과 고객 경험을 개선해 보세요. 어드밴스 영어 문법 수정에서 어조 및 스타알 향상까지 글 작성을 위해 포괄적으로 지원합니다
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Real-timewritingsuggestions.png" alt="suggestions" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>애플리케이션 내 실시간 고급 글쓰기 지원</h3>
                                    <p>트링카 AI는 애플리케이션(앱) 내에서 실시간으로 복잡한 문법 오류를 확인합니다. 트링카는 문법 검사 외에도 어휘, 어조, 구문, 표현 등에서 글을 향상해
                                        드립니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Qualityassessment.png" alt="Quality" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>맞춤형 점수 및 개인 사전</h3>
                                    <p>사용자 지정 가능한 채점 알고리즘을 이용하여 글의 점수를 채점하고 사용자 개별 사전을 통해 글 쓰기 기능을 개인화할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/WhiteLabel.png" alt="WhiteLabel" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>화이트 레이블</h3>
                                    <p>완벽한 트링카 화이트 레이블링을 통해 제품이 매끄럽게 통합됩니다. 트링카의 맞춤형 화이트 레이블 솔루션을 사용하여 브랜드가 가진 가치관과 신뢰를 지속적으로
                                        유지하고 활용할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/DedicatedSupport.svg" alt="support" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>전담 지원</h3>
                                    <p>전담 매니저가 배정되어 전화, 문서, 그리고 영상 등을 통해 트링카를 최대한 활용할 수 있도록 지원합니다.
                                    </p>
                                </div>
                            </div>
                        </li>

                    </ul>
                    <!-- <span class="bottom_diviedLine"></span> -->
                    <!-- <span class="bottom_diviedLine1"></span> -->

                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>모든 사용 사례에
                        <br>적합한 통합 유연성</h2>
                    <div class="HeadingSubLine"></div>
                    <p>트링카의 다양한 기능을 사용하여 성장을 주도해 줄 기능을 구축해 보세요.</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>실시간 지원</h4>
                                <p>사용자가 편안한 앱을 벗어나지 않고도 즉시
                                    <br>피드백을 작성할 수 있도록 하세요.</p>
                                <ul>
                                    <li>3000가지 이상의 문법 검사</li>
                                    <li>자세한 설명</li>
                                    <li>맞춤형 수정</li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>글쓰기 품질 평가</h4>
                                <p>트링카 AI가 제공하는 맞춤화 가능한 품질점수와 오류 분석은 학습 관리 시스템(LMS), 이러닝 앱 등에서 맞춤형 학습 경험을 강화해 줍니다.
                                </p>
                                <ul>
                                    <li>글 품질점수</li>
                                    <li>카테고리화 된 글쓰기 오류 보고서</li>
                                    <li>대화형 수정과 설명</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="all_usecases_item all_usecases_item_last">
                                <h4>기성품의 개인 맞춤화</h4>
                                <p>트링카를 사용하면 사용자 사전, 사용자 지정 가능한 수정 및 스타일 가이드, 맞춤형 대시보드 지원을 통해 개인 맞춤화된 경험을 제공할 수 있습니다.</p>
                                <ul>
                                    <li>사용자가 개인 사전을 만들 수 있음</li>
                                    <li>브랜드/앱과 관련된 맞춤형 스타일 가이드 추가</li>
                                    <li>강력한 데이터 수집과 모니터링을 통해 정밀한 통찰 도출</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>독점 소프트웨어 및 워크플로와 통합</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>트링카는 통합이 손쉬워 팀이 기존 소프트웨어 내에서 바로 모든 혜택을 누릴 수 있습니다. 따라서 효과적인 글쓰기가 생산적으로 원활하게 이루어집니다.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>자바스크립트</h3>

                    <p>
                        브라우저나 애플리케이션에 작은 자바스크립트(JS) 코드 스니펫을 삽입하기만 하면 모든 팀 구성원이 트링카를 사용할 수 있습니다.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>API</h3>
                    <p>
                        트링카의 강력한 API는 기존 애플리케이션에서 트링카를 바로 사용하도록 도와드립니다. 간단한 API 아키텍처를 통해 손쉽게 통합 작업을 할 수 있습니다.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>온프레미스</h3>
                    <p>로컬 서버와 클라우드 서버를 막론하고 엔터프라이즈 인프라에서 트링카를 호스팅하여 효과적인 글쓰기와 최대 기밀성을 보장해 보세요.
                    </p>

                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>클라우드 에디터</h3>


                    <p>
                        안전한 웹 기반 애플리케이션을 통해 어디에서나 트링카의 잠재력을 최대로 활용해 보세요.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>MS Word 추가 기능</h3>
                    <p>
                        MS Word 내에서 글쓰기 제안이 전달되도록 하여 팀의 생산성을 높여보세요.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>브라우저 플러그인</h3>
                    <p>
                        즐겨 사용하는 모든 브라우저에 적합한 플러그인을 통해 모든 웹사이트에서 실시간 글쓰기 지원을 받아보세요.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>나에게 맞는 맞춤형 가격 책정</h2>
                </div>
                <p>트링카는 고유한 요구 사항에 맞게끔 개별 사용자나 사용량에 기반하여 가격을 유연하게 책정해 드립니다.
                    <br>추가 비용 없이 실시간으로 사용자를 전환하고 사용 제한을 적용해 보세요.
                    <br>구매 주문서(PO)/인보이스를 통해 번거롭지 않은 맞춤형 계약 및 단일 결제 옵션을 생성하도록 협력해 드리겠습니다.</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">Get a Quote</a> -->

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">견적 문의</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>안전, 보안, 신뢰</h3>
                        <p>트링카는 데이터 보안과 개인 정보 보호를 최우선으로 생각합니다. 내 모든 데이터는 강력하게 암호화되어 안전하게 저장됩니다. 다른 사람은 내 데이터에 액세스할 수 없습니다. 트링카는
                            글쓰기 제안을 받으면 데이터 저장을 제거하는 고유한 플랜을 제공해 드립니다.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe-secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="AI" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>AI 소개</h3>
                        <p>트링카는 최신 머신러닝(ML) 및 자연어 처리(NLP) 기술을 사용하여 문법 오류를 식별하고 언어 향상을 제안합니다. 의학, 생명과학, 생물학, 물리학, 공학, 인문학, 비즈니스
                            및 예술을 포함한 1300개 이상의 주제 영역을 망라하며 모범적으로 작성된 논문 및 기사 수백만 건을 바탕으로 훈련되기에 해당 주제에 가장 적절한 제안을 제공합니다.</p>
                        <p>트링카는 장벽 없는 커뮤니케이션을 통해 미래를 만들어가고자 하는 깊은 열망을 품은 언어학자, 의학 에디터, 데이터 과학자 및 엔지니어로 이루어진 팀이 개발했습니다.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>트링카로 비즈니스 커뮤니케이션을 혁신해 보세요</p>
    <button data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">견적 문의</button>
</div>

<app-enterprise-modal></app-enterprise-modal>